import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useCompaniesStore = defineStore('companies', {
  state: () => ({
    data: undefined,
    allData: undefined,
    options: undefined,
  }),
  getters: {
    getCompanies: (state) => state.data?.data,
    getCompanyOptions: (state) => state.options?.data ?? [],
    getVehicleManufacturerOptions: (state) => state.options?.data?.filter(c => !!c.vehicle_manufacturer) ?? [],
    getAllCompanies: (state) => state.allData?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexCompanyOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'companies', ['id','name','vehicle_manufacturer']);
          const response = await axios.get('companies', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexCompanies(params = {}) {
      try {
        const response = await axios.get('companies', {params} );
        this.data = response.data;
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexComponentSuppliers(primaryCompanyId, params = {}) {
      try {
        const response = await axios.get(`companies/${primaryCompanyId}/component-suppliers`, { params });
        return response.data;
      } catch (error) {
        console.error(error?.response || error);
        throw (error?.response || error);
      }
    },
    async indexAllCompanies(params = {}, silent = true) {
      if(!silent)
        this.allData = undefined;

      if(this.allData === undefined){
        try {
          const response = await axios.get('companies/all', {params} );
          this.allData = response.data;
          return response.data;
        } catch (error) {
          console.error(error.response);
          throw error.response;
        }
      }

      return this.allData;
    },
    async createCompany(params = {}) {
      try {
        const response = await axios.get('companies/create', {params} );
        return useCreateForm('companies', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showCompany(companyId, params = {}) {
      try {
        const response = await axios.get(`companies/${companyId}`, {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editCompany(companyId, params = {}) {
      try {
        const response = await axios.get(`companies/${companyId}/edit`, {params} );
        return useEditForm(`companies/${companyId}`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteCompany(companyId, params = {}) {
      try {
        const response = await axios.delete(`companies/${companyId}`, {params} );
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Company Deleted',
          detail: `Company has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
